<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'ResourcesResearchHeader',
  inject: ['wp']
}
</script>
